// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"78334abe","453":"0796f13d","455":"58aeebe0","977":"2fd24133"}[chunkId] + ".chunk.js";
};